import { ProtectorType } from 'core/constants';

import { AuditOption, YES_NO_NA_OPTIONS } from './types';

/** Copied on selection, so the two questions stay independent. */
export interface ResponseSet {
  id: string;
  label: string;
  options: AuditOption[];
  questionType: ProtectorType;
}

export const responseSetLabels = (options: AuditOption[]): string[] =>
  options.map((option) => option.value.trim()).filter(Boolean);

export const responseSetLabel = (options: AuditOption[]): string => responseSetLabels(options).join(' / ');

export const responseSetId = (options: AuditOption[]): string => responseSetLabel(options).toLowerCase();

/** Labels alone are not unique: the fixed Yes/No/N-A type and a dropdown can carry the same answers. */
export const responseSetIdentity = (set: Pick<ResponseSet, 'id' | 'questionType'>): string =>
  `${set.questionType}:${set.id}`;

export const yesNoNaOptions = (): AuditOption[] =>
  YES_NO_NA_OPTIONS.map(({ key, value, colour }) => ({ key, value, score: null, colour }));

const option = (key: string, value: string, colour: string | null): AuditOption => ({
  key,
  value,
  score: null,
  colour,
});

const notApplicable = (): AuditOption => option('na', 'N/A', null);

const set = (questionType: ProtectorType, options: AuditOption[]): ResponseSet => ({
  id: responseSetId(options),
  label: responseSetLabel(options),
  questionType,
  options,
});

export const SEEDED_RESPONSE_SETS: ResponseSet[] = [
  // Offered alongside the dropdowns, but stored as its own type — the server fixes its three option keys.
  set(ProtectorType.YesNoNa, yesNoNaOptions()),
  set(ProtectorType.SingleChoice, [
    option('pass', 'Pass', 'success'),
    option('fail', 'Fail', 'error'),
    notApplicable(),
  ]),
  set(ProtectorType.SingleChoice, [
    option('safe', 'Safe', 'success'),
    option('at-risk', 'At risk', 'warning'),
    notApplicable(),
  ]),
  set(ProtectorType.SingleChoice, [
    option('good', 'Good', 'success'),
    option('fair', 'Fair', 'warning'),
    option('poor', 'Poor', 'error'),
    notApplicable(),
  ]),
];
